import { render, staticRenderFns } from "./ed-pdf-viewer.vue?vue&type=template&id=44f67428&"
import script from "./ed-pdf-viewer.ts?vue&type=script&lang=ts&"
export * from "./ed-pdf-viewer.ts?vue&type=script&lang=ts&"
import style0 from "./ed-pdf-viewer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports